module.exports = __webpack_public_path__ + "static/media/service-trade-mobile.1eb181c7.png";